import keyMirror from 'keymirror';

export const addWysiwygAudioModalActionTypes = keyMirror({
	HANDLE_ADD_WYSIWYG_AUDIO_MODAL: null,
	UPLOAD_WYSIWYG_AUDIO_REQUEST: null,
	UPLOAD_WYSIWYG_AUDIO_SUCCESS: null,
	UPLOAD_WYSIWYG_AUDIO_ERROR: null,
	CLEAR_WYSIWYG_AUDIO_STATE: null,
});

export const getAudioOptionsList = (t) => [
	{
		name: 'replay',
		title: t('modals.add_wysiwyg_audio_modal.option_replay'),
	},
	{
		name: 'rewinding',
		title: t('modals.add_wysiwyg_audio_modal.option_rewinding'),
	},
	{
		name: 'speed',
		title: t('modals.add_wysiwyg_audio_modal.option_speed'),
	},
];

export const createAudioNode = (data, node) => {
	const nodeModule = node || document.createElement('div');

	nodeModule.setAttribute('contenteditable', false);
	nodeModule.setAttribute('data-val', JSON.stringify(data));
	nodeModule.setAttribute('id', data.id);
	nodeModule.classList.add('audio-content');

	return nodeModule;
};
